import { AppConfig } from "./AppConfig";

export const debug = (appConfig: AppConfig, message: string, object?: any) => {
    if (!!appConfig.shellConfig.debug) {
        if (object) {
            console.log(message, object);
        } else {
            console.log(message);
        }
    }
};

export const error = (appConfig: AppConfig, message: string, object?: any) => {
    if (!!appConfig.shellConfig.debug) {
        if (object) {
            console.error(message, object);
        } else {
            console.error(message);
        }
    }
};